import React from 'react';

import Avatar from 'components/Misc/Avatar';
import { Title } from 'components/Misc/Typography';

import Subject from 'containers/Administrator/Grades/Profile/Journal/Subject';

import { useGradeJournalStore } from 'store/grade/useGradeJournalStore';

const Student = ({ student }) => {
	// Use grade student store
	const subjects = useGradeJournalStore(state => state.result.subjects);

	return (
		<tr className="group-one">
			<td className="sticky left-0 z-10 bg-white group-one-last:first:rounded-bl-lg group-one-last:last:rounded-br-lg dark:bg-neutral-800 p-2 first:pl-3 text-neutral-700 dark:text-neutral-200 text-sm font-bold border-neutral-100 dark:border-neutral-700 first:border-l border-r border-b group-one:first:rounded-bl-lg group-one:last:rounded-br-lg group-two-last:first:rounded-bl-lg group-two-last:last:rounded-br-lg">
				<div className="flex items-center space-x-2">
					<Avatar
						small
						src={student.avatar}
						alt={student.fullName}
						online={student.online}
					/>

					<Title
						title={`${student.name} ${student.surname}`}
						className="flex-1"
					/>
				</div>
			</td>

			{subjects?.map(subject =>
				<Subject key={subject.id} subject={subject} subjects={student.subjects} />
			)}
		</tr>
	);
};

export default Student;